"use strict";

angular.module("internal.exams").controller("InternalExamPermissionExaminersModal", ['$scope',
    'EXExaminers',
    'LicenseCategoryLevels',
    '$uibModalInstance',
    function ($scope, EXExaminers, LicenseCategoryLevels, $uibModalInstance) {
        $scope.certs = [];

        LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (licenseCategoryLevels) {
            $scope.license_category_levels = licenseCategoryLevels;
            for (var x in licenseCategoryLevels) {
                var format = {
                    name: licenseCategoryLevels[x].combined_name, id: licenseCategoryLevels[x].id
                };
                $scope.certs.push(format);
            }
        });

        $scope.add = function (id) {
            if (!$scope.adding) {
                $scope.adding = true;
                EXExaminers.save({ id: id }).then(function () {
                    $scope.adding = false;
                    $scope.refresh = new Date();
                });
            }
        }

        $scope.availableColumns = [
            {
                label: 'Name',
                field: 'fullName'
            },
            {
                label: 'Username',
                field: 'userName'
            },
            {
                label: 'Email',
                field: 'email'
            },
            {
                label: 'Add',
                html: '<hlp-icon classes="add" name="add" ng-click="$parent.$parent.$parent.$parent.$parent.add($parent.$parent.$parent.record.id)"></hlp-icon>',
                type: 'empty'
            }
        ];

        $scope.availableFilters = [
            {
                name: 'All Personnel Types',
                field: 'internal',
                options: [
                    { name: 'External', id: false },
                    { name: 'Internal', id: true }
                ]
            },
            {
                name: 'Current Certification',
                field: 'currentCertificationLevelIdsString',
                options: $scope.certs,
                contains: true
            }
        ];

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
    ;